import React, { Component } from "react";
import { connect } from "react-redux";
import { Nav, NavItem, NavLink, Button, Input, Label } from "reactstrap";
import ExtratoConta from "../usuario/perfil/extratoConta";
import {
  getPaymentsMade,
  requestWithdraw,
  getPaymentsReceived
} from "../../providers/paymentProvider";
import Toast from "../utils/Toast";
import WithdrawsHistory from "./WithdrawsHistory";
import CreditCards from "./CreditCards";

const tabs = {
  statement: 0,
  creditCards: 1,
  configurations: 2,
  withdrawsHistory: 3
};

class FinanceOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: tabs.statement,
      paymentsMade: [],
      paymentsReceived: [],
      withdraw: 0,
      successMessage: "",
      errorMessage: ""
    };
  }

  async componentDidMount() {
    this.getPaymentsMade();
  }

  getPaymentsMade = async () => {
    const { email } = this.props.profile;

    const payments = await getPaymentsMade(email);
    console.log(payments);
    if (payments.error) {
      return;
    }
    this.setState({ paymentsMade: payments.result.results });
  };

  renderStatement() {
    return <ExtratoConta payments={this.state.paymentsMade} />;
  }

  renderCreditCards() {
    return <CreditCards profile={this.props.profile} />;
  }

  renderContent() {
    switch (this.state.activeTab) {
      case tabs.statement:
        return this.renderStatement();
      case tabs.creditCards:
        return this.renderCreditCards();
    }
  }

  isActive(tab) {
    let className = null;
    if (tab === this.state.activeTab) {
      className = "active";
    }
    return className;
  }

  render() {
    return (
      <div className="col-md-12">
        <div className="mt-4">
          <h2 id="tipo-texto">Opções Financeiras</h2>
        </div>
        <Nav className="nav-account-content">
          <NavItem>
            <NavLink
              className={this.isActive(tabs.statement)}
              href="#"
              onClick={() => this.setState({ activeTab: tabs.statement })}
            >
              Histórico de compras
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.isActive(tabs.creditCards)}
              href="#"
              onClick={() => this.setState({ activeTab: tabs.creditCards })}
            >
              Cartões de crédito
            </NavLink>
          </NavItem>
        </Nav>
        <div>
          <div className="profile-card">{this.renderContent()}</div>
        </div>
        {this.state.successMessage ? (
          <Toast message={this.state.successMessage} type="success" />
        ) : null}
        {this.state.errorMessage ? (
          <Toast message={this.state.errorMessage} type="error" />
        ) : null}
      </div>
    );
  }
}

//export default FinanceOptions;

const mapStateToProps = state => {
  return {
    profile: state.user.userInfo
  };
};
export default connect(mapStateToProps)(FinanceOptions);
